
import React, { Component } from 'react';
import { Button, Card, CardBody, CardText, CardTitle, CardGroup, TabPane } from 'reactstrap';
import { Redirect } from 'react-router';
import cookie from 'react-cookies';
import { apiBaseUrl } from '../../configs/configs';
import Swal from 'sweetalert2';
import axios from 'axios';
import { isEmpty } from 'lodash';
// import { defaultCurrency, apiBaseUrl } from '../../../configs/configs';

class PredictionPriceBreakup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            rows: [{
                name: "Rank 1",
                startRank: 1,
                endRank: 1,
                percentage: 100,
                price: 0,
                nameError: "",
                percentageError: "",
                startRankError: "",
                endRankError: '',
                isError: false,
                price_each: 100,
                percentage_each: 100,
                percentage_eachError: "",
            }],
            contestData: {},
            predictionData: {},
            totalWinners: 1,
            lastRow: 0,
            totalPercentage: 100,
            totalPrice: 0,
            restAmount: 0
        };
        this.updateCustomBreakup = this.updateCustomBreakup.bind(this);
        this.validateFields = this.validateFields.bind(this);
        this.checkEmptyOrZero = this.checkEmptyOrZero.bind(this);
        this.getPoolPrice = this.getPoolPrice.bind(this);
    }
    distributionAmount = (data) => {
        var Comissionfee = data.admin_commission
        const totalSlotFees = data.slots * data.entry_fee
        const restFee = Comissionfee / 100 * totalSlotFees
        const totalRestFee = totalSlotFees - restFee
        this.setState({ restAmount: totalRestFee })
        return totalRestFee
    }

    async updateCustomBreakup() {
        var formData = this.state.rows;
        let totalWinners = this.state.totalWinners;
        const response = await this.validateFields(formData);
        let contest_size = this.state.contestData.contest_size;
        if (response) {
            // alert('please fix all errors...');
        } else {

            if (totalWinners > contest_size) {
                alert('total winners size should be less than equal to contest size !');
                return;
            }

            var predefinedData = this.state.rows;
            const data = []
            for (var oneData of predefinedData) {
                data.push({
                    "price": oneData.price,
                    "rank": oneData.name,
                    "startRank": oneData.startRank,
                    "endRank": oneData.endRank,
                    "price_each": oneData.price_each,
                    "total_price": oneData.price,
                    "percentage_each": oneData.percentage_each,
                    "percentage" : oneData.percentage,
                })
                isEmpty(oneData.endRankError) && delete oneData.endRankError
                isEmpty(oneData.startRankError) && delete oneData.startRankError
                isEmpty(oneData.percentage_eachError) && delete oneData.percentage_eachError
                isEmpty(oneData.nameError) && delete oneData.nameError
                isEmpty(oneData.percentageError) && delete oneData.percentageError
            }
            var type = 1;

            // var contest_id = this.state.contestData._id;

            const requestBody = {
                _id: this.props.match.params._id,
                price_breakup: data,
                pred_autocreate: this.state.predictionData.pred_autocreate
            };
            // const formData1 = new FormData();

            // formData1.append('contest_id', contest_id);
            // formData1.append('type', type);
            // formData1.append('totalWinners', totalWinners);
            // formData1.append('breakup', JSON.stringify(predefinedData));

            const token = cookie.load('token');
            // return false
            const updateContestBreakupUrl = `${apiBaseUrl}/prediction/match/${this.props.match.params.match_id}/series/${this.props.match.params.series_id}`;
            const response = await axios.post(updateContestBreakupUrl, requestBody, {
                headers: {
                    "token": token,
                }
            })
            if (response.data.status === 'success') {
                Swal.fire('Updated Prediction Breakup')
            }
        }
    }

    async validateFields(formData) {
        const rows = [...this.state.rows];
        var isError = false;
        var totalPercentage = 0;
        for (var key in formData) {
            var formValue = formData[key];
            console.log(formValue, "formValue");
            var oldRow = rows[key];

            if (formValue.name == '') {
                oldRow['nameError'] = "Name is required";
                isError = true;

            } else {

                oldRow['nameError'] = "";
            }

            if (formValue.startRank == '' || formValue.startRank == '0') {
                oldRow['startRankError'] = "Start Rank should greater than 0";
                isError = true;

            } else {
                oldRow['startRankError'] = "";
            }



            if (formValue.endRank == '0' || formValue.endRank < formValue.startRank) {
                oldRow['endRankError'] = "End Rank should greater than 0 or equal";
                isError = true;

            } else {
                oldRow['endRankError'] = "";

            }


            if (formValue.percentage_each == '' || formValue.percentage_each == '0') {
                oldRow['percentage_eachError'] = "percentage should greater than 0";
                isError = true;

            } else {
                oldRow['percentage_eachError'] = "";
            }

            if (formValue.percentage == '' || formValue.percentage == '0') {
                oldRow['percentageError'] = "percentage should greater than 0";
                isError = true;

            } else {
                totalPercentage = totalPercentage + this.priceFloatFixed(formValue.percentage);
                oldRow['percentageError'] = "";
            }

            rows[key] = oldRow;
            this.setState({
                rows
            });


        }

        if (isError) {
            this.setState({
                isError: true
            });
        } else {
            if (totalPercentage > '101' || totalPercentage < '99') {
                alert('Total percentage should be greater than 99 or equal to 100');
                isError = true;
                this.setState({
                    isError: true
                });
            }
        }

        return isError;
    }

    getPoolPrice() {
        const { slots, entry_fee, admin_commission } = this.state.contestData
        const admnAmount = (admin_commission / 100) * slots * entry_fee
        const pricePool = (slots * entry_fee) - admnAmount
        console.log({ pricePool })
        return pricePool
    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }
    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to={
                {
                    pathname: `/contests_schedule/prediction/${this.props.match.params.match_id}/${this.props.match.params.series_id}`,
                    alert: {
                        color: this.state.alertClass,
                        message: this.state.alertMessage
                    }
                }
            } />
        }
    }
    priceFloatFixed(amount) {
        return +(Math.round(amount + "e+2") + "e-2");
    }
    componentDidMount() {
        if (this.props.match.params._id) {
            this.getPredicition();
        }
    }

    getPredicition = async () => {
        const url = `${apiBaseUrl}/prediction/${this.props.match.params._id}`
        const response = await fetch(url)
        if (response.status === 200) {
            const jsonResponse = await response.json();
            if(!isEmpty(jsonResponse.data.price_breakup)){
                this.setState({ predictionData: jsonResponse.data, rows: jsonResponse.data.price_breakup })
            }else{
                this.setState({ predictionData: jsonResponse.data })
            }
            this.distributionAmount(jsonResponse.data)
        } else if (response.status === 401) {
            cookie.remove('token');
            return <Redirect to='/login' />
        } else {
            this.setState({ loading: false });
            return new Error();
        }
    }

    updatePrice_copy = (percentage, startRank, endRank) => {

        var endRank = parseInt(endRank);
        var startRank = parseInt(startRank);
        var prizeAmount = this.state.contestData.winning_amount;
        if (endRank > startRank) {
            var winnerCount = (endRank - startRank) + 1;
        } else {
            var winnerCount = 1;
        }

        var price = this.priceFloatFixed(((this.priceFloatFixed(percentage) * prizeAmount) / 100) / winnerCount);
        // console.log('updatePrice', percentage, startRank, endRank, winnerCount, price);
        return price;
    }
    updatePercentageTotal = (percentage_each, startRank, endRank) => {

        endRank = parseInt(endRank);
        startRank = parseInt(startRank);
        let percentage = 0;
        let winnerCount = 1;
        if (endRank > startRank) {
            winnerCount = (endRank - startRank) + 1;
        }

        if (!this.checkEmptyOrZero(percentage_each)) {
            percentage = winnerCount * percentage_each;
        }

        return percentage.toFixed(2);
    }
    updatePriceEach = (percentage_each, startRank, endRank) => {
        endRank = parseInt(endRank);
        startRank = parseInt(startRank);

        let prizeAmount = this.state.restAmount;

        let price = 0;
        let winnerCount = 1;
        if (endRank > startRank) {
            winnerCount = (endRank - startRank) + 1;
        }


        // if (!this.checkEmptyOrZero(percentage_each)) {
        //     price = this.priceFloatFixed((percentage_each * prizeAmount) / 100);
        // }

        if (!this.checkEmptyOrZero(percentage_each)) {
            price = this.priceFloatFixed((percentage_each * prizeAmount) / 100);
        }
        // console.log('updatePrice', percentage, startRank, endRank, winnerCount, price);
        return price;
    }

    updatePriceTotal = (priceEach, startRank, endRank) => {
        endRank = parseInt(endRank);
        startRank = parseInt(startRank);
        priceEach = parseFloat(priceEach);
        let price = 0.00;

        let winnerCount = 1;
        if (endRank > startRank) {
            winnerCount = (endRank - startRank) + 1;
        }

        if (!this.checkEmptyOrZero(priceEach)) {
            price = winnerCount * priceEach;
        }
        // this.setState({totalPrice: price});
        return price;
    }

    updateTotalPricePercentage() {
        var totalPercentage = 0;
        let totalPrice = 0;
        var formData = this.state.rows;
        for (var key in formData) {
            var formValue = formData[key];
            totalPercentage = totalPercentage + this.priceFloatFixed(formValue.percentage);
            totalPrice = totalPrice + this.priceFloatFixed(formValue.price);
        }
        this.setState({ totalPercentage: totalPercentage, totalPrice: totalPrice });
    }

    handleChange = idx => e => {
        const { name, value } = e.target;
        const rows = [...this.state.rows];
        // console.log('old', rows);
        // alert(idx);
        var oldRow = rows[idx];
        oldRow[name] = value;
        //kamal
        if (name != 'name') {
            oldRow['price_each'] = this.updatePriceEach(oldRow.percentage_each, oldRow.startRank, oldRow.endRank);
            // oldRow['price_each'] = this.state.totalRestFee;
            oldRow['percentage'] = this.updatePercentageTotal(oldRow.percentage_each, oldRow.startRank, oldRow.endRank);
            oldRow['price'] = this.updatePriceTotal(oldRow['price_each'], oldRow.startRank, oldRow.endRank);
        }

        this.updateTotalPricePercentage();

        if (name == 'name') {
            if (value == '') {
                oldRow['nameError'] = "Name is required";
            } else {
                oldRow['nameError'] = "";
            }
        }

        if (name == 'startRank') {
            if (parseInt(oldRow['endRank']) == parseInt(value)) {
                oldRow['name'] = 'Rank ' + value;
            } else {
                oldRow['name'] = 'Rank ' + value + '-' + oldRow['endRank'];
            }


            oldRow['name'] = 'Rank ' + value + '-' + oldRow['endRank'];
            if (value == '' || value == '0') {
                oldRow['startRankError'] = "Start should be greater than 0";
            } else {
                var invalidStartRange = false;
                for (var key in rows) {
                    var formValue = rows[key];

                    // console.log('key****-----*****', key, idx, value, formValue.startRank, formValue.endRank);
                    if (key != idx) {
                        if (formValue.endRank == '0') {
                            if (formValue.startRank == value) {
                                invalidStartRange = true;
                                // alert('Invalid range');
                            }
                        } else {
                            if (parseInt(formValue.startRank) <= value && value <= parseInt(formValue.endRank)) {
                                invalidStartRange = true;
                                // alert('invalid range selected');
                            }
                        }

                    } else {
                        console.log('else');
                    }

                }
                if (invalidStartRange) {
                    oldRow['startRankError'] = "Invalid range selected";
                } else {
                    oldRow['startRankError'] = "";
                }
            }
        }

        if (name == 'endRank') {
            if (parseInt(oldRow['startRank']) == parseInt(value)) {
                oldRow['name'] = 'Rank ' + oldRow['startRank'];
            } else {
                oldRow['name'] = 'Rank ' + oldRow['startRank'] + '-' + value;
            }

            if (value != '' && value != '0') {

                this.setState({
                    totalWinners: value
                });
                if (value < parseInt(rows[idx].startRank)) {
                    oldRow['endRankError'] = "End range should greater than start range";
                } else {
                    var invalidEndRange = false;
                    for (var key in rows) {
                        var formValue = rows[key];
                        if (key != idx) {
                            if (parseInt(formValue.startRank) <= value && value <= parseInt(formValue.endRank)) {
                                invalidEndRange = true;
                            }

                        }

                    }
                    if (invalidEndRange) {
                        oldRow['endRankError'] = "Invalid range selected";
                    } else {
                        oldRow['endRankError'] = "";
                    }
                }
            } else {
                oldRow['endRankError'] = "";
            }
        }

        if (name == 'percentage') {
            if (value == '' || value == '0') {
                oldRow['percentageError'] = "Invalid percentage";
            } else {
                oldRow['percentageError'] = "";
            }
        }

        // if (name == 'percentage_each') {
        //     if (value == '' || value == '0') {
        //         oldRow['percentage_eachError'] = "Invalid percentage";
        //     } else {
        //         oldRow['percentage_eachError'] = "";
        //     }
        // }

        rows[idx] = oldRow;

        this.setState({
            rows
        });
    };


    checkEmptyOrZero = (val) => {
        if (val == '0' || val == '') {
            return true;
        }
        return false;
    }

    handleAddRow = () => {
        const rows = [...this.state.rows];

        let lastRow = this.state.lastRow;
        let oldRow = rows[lastRow];
        let isError = false;
        // alert(lastRow);
        // alert(rows[lastRow]['endRank']);
        if (this.checkEmptyOrZero(oldRow['endRank'])) {
            oldRow['endRankError'] = "Invalid end rank";
            isError = true;
        }

        if (this.checkEmptyOrZero(oldRow['percentage_each'])) {
            oldRow['percentage_eachError'] = "percentage should greater than 0";
            isError = true;
        }
        if (isError) {
            rows[lastRow] = oldRow;
            this.setState({ rows });

            return;
        }

        let nextRow = lastRow + 1;
        let nextRowStartRank = parseInt(rows[lastRow]['endRank']) + 1;

        const item = {
            name: "Rank " + nextRowStartRank + " -0",
            startRank: nextRowStartRank,
            endRank: 0,
            percentage: 0,
            price: 0,
            nameError: "",
            percentageError: "",
            startRankError: "",
            endRankError: '',

            percentage_each: 0,
            price_each: 0,
            percentage_eachError: "",
        };
        this.setState({
            rows: [...this.state.rows, item],
            lastRow: nextRow
        });
    };

    handleRemoveRow = () => {
        let lastRow = this.state.lastRow;
        if (lastRow > 0) {
            this.setState({
                rows: this.state.rows.slice(0, -1),
                lastRow: lastRow - 1
            });
        }

    };
    handleRemoveSpecificRow = (idx) => () => {
        const rows = [...this.state.rows]
        rows.splice(idx, 1)
        this.setState({ rows })
    }
    render() {
        return (
            <TabPane tabId="2">

                <div>
                    {this.renderRedirect()}
                    <CardGroup>
                        <Card>
                            <CardBody>
                                <CardTitle></CardTitle>
                                <CardText>SLOTS<br /> {this.state.predictionData.slots && this.state.predictionData.slots}</CardText>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <CardTitle></CardTitle>
                                <CardText>
                                    ENTRY FEE<br />
                                    {
                                        this.state.predictionData.entry_fee && this.state.predictionData.entry_fee
                                    }
                                    {/* {defaultCurrency} {this.props.contestData.winning_amount || this.getPoolPrice()} */}
                                </CardText>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <CardTitle></CardTitle>
                                {/* <CardText>
                                DISTRIBUTION AMOUNT <br />
                                    {
                                        this.distributionAmount(this.state.predictionData)
                                    }
                                </CardText> */}
                                <CardText>
                                    DISTRIBUTION AMOUNT <br />
                                    {this.state.restAmount}
                                </CardText>
                            </CardBody>
                        </Card>
                    </CardGroup>

                    <br />
                    <div className="container">
                        <div className="row clearfix">
                            <div className="col-md-12 column">

                                <span
                                    readOnly="readOnly"
                                    type="text"
                                    name="totalWinners"
                                    value={this.state.totalWinners}
                                    className="float-right"
                                >Total Winners: {this.state.totalWinners}</span>
                                <br /><br />
                                <table className="table table-bordered table-hover" id="tab_logic" >
                                    <thead>
                                        <tr>
                                            <th className="text-center"> # </th>
                                            <th className="text-center"> Name </th>
                                            <th className="text-center"> Start Rank </th>
                                            <th className="text-center"> End Rank </th>
                                            <th className="text-center"> Percentage (each) </th>
                                            <th className="text-center"> Price (each) </th>
                                            <th className="text-center"> Total Percentage ({this.state.totalPercentage}) </th>
                                            <th className="text-center"> Total Price ({this.state.totalPrice})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.rows.map((item, idx) => (
                                            <tr id="addr0" key={idx}>
                                                <td>{idx + 1}</td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="name"
                                                        value={this.state.rows[idx].name}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                        readOnly={true}
                                                    />
                                                    <span style={{ color: "red" }}>{this.state.rows[idx].nameError}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        readOnly="readOnly"
                                                        type="text"
                                                        name="startRank"
                                                        value={this.state.rows[idx].startRank}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                    <span style={{ color: "red" }}>{this.state.rows[idx].startRankError}</span>

                                                </td>
                                                <td>
                                                    <input
                                                        readOnly={this.state.lastRow != idx}
                                                        type="number"
                                                        name="endRank"
                                                        value={this.state.rows[idx].endRank}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                    <span style={{ color: "red" }}>{this.state.rows[idx].endRankError}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        type="text"
                                                        name="percentage_each"
                                                        value={this.state.rows[idx].percentage_each}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                    <span style={{ color: "red" }}>{this.state.rows[idx].percentage_eachError}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        readOnly="readOnly"
                                                        type="text"
                                                        name="price_each"
                                                        value={this.state.rows[idx].price_each}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        readOnly="readOnly"
                                                        type="text"
                                                        name="percentage"
                                                        value={this.state.rows[idx].percentage}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                    <span style={{ color: "red" }}>{this.state.rows[idx].percentageError}</span>
                                                </td>
                                                <td>
                                                    <input
                                                        readOnly="readOnly"
                                                        type="text"
                                                        name="price"
                                                        value={this.state.rows[idx].price}
                                                        onChange={this.handleChange(idx)}
                                                        className="form-control"
                                                    />
                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <button onClick={this.handleAddRow}
                                    className="btn btn-primary" disabled={this.state.rows[this.state.lastRow]['endRank'] == '0' || this.state.rows[this.state.lastRow]['endRank'] == '' || this.state.rows[this.state.lastRow]['percentage_each'] == '0' || this.state.rows[this.state.lastRow]['percentage_each'] == ''}>
                                    Add Row
                                </button>
                                <button onClick={this.handleRemoveRow} disabled={this.state.lastRow == '0'} className="btn btn-danger float-right">
                                    Delete Last Row
                                </button>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div>
                        {/* <Button color="primary" disabled={this.state.isError} onClick={this.updateCustomBreakup}>Update Breakup</Button> */}
                        <Button color="primary" onClick={this.updateCustomBreakup}>Update Breakup</Button>
                    </div>
                </div>
            </TabPane>

        );
    }
}

export default PredictionPriceBreakup;